export const MAX_VIDEO_SIZE = 5 * 1024 * 1024 * 1024; // 5GB max video size
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB max image size
export const MAX_FILES = 10;
